import { stringFromPrefixedString } from "../utils";
import { Schema as S } from "effect";
import * as SubscriberId from "./SubscriberId";
import * as SubscriptionEnvironment from "./SubscriptionEnvironment";
import * as SubscriptionProvider from "./SubscriptionProvider";
// A full subscription id is a combination of the subscription id,
// the subscription provider, and whether it's a sandbox subscription
export const Schema = S.Struct({
    id: SubscriberId.Schema,
    provider: SubscriptionProvider.Schema,
    env: SubscriptionEnvironment.Schema
});
export const FromString = stringFromPrefixedString("sw_cus_", S.compose(S.StringFromBase64Url, S.parseJson(Schema)));
export const Type = Schema.Type;
export const makeUnsafe = ({ id, provider, env })=>({
        id,
        provider,
        env
    });
export const make = ({ id, provider, env })=>S.decodeUnknown(Schema)({
        id,
        provider,
        env
    });
